<button class="btn btn-primary" (click)="hideOrShowMenu()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-angle-down" [hidden]="isMenuExpanded"></i>
    <i class="fas fa-angle-up" [hidden]="!isMenuExpanded"></i>
</button>
